import type { LocalizedString } from '@onrunning/backstage-models';
import { BackstageTheme } from '../models/backstage-theme.enum';

const fallBackLocale: keyof LocalizedString = 'en-US';

export const globalConstants = {
  sizeTypes: ['us', 'eu', 'uk', 'jp', 'br'],
  defaultLocale: navigator.languages?.[0] ?? navigator.language ?? fallBackLocale,
  fallBackLocale: fallBackLocale as keyof LocalizedString,
  theme: BackstageTheme.light,
  dateFormat: 'YYYY-MM-DD',
  dateLocalFormat: 'L',
  earliestPickupDayOffset: 1, // Number of days from the current day
  countryCodeAndCountryDelimiter: '---',
};

export interface State {
  code: string;
  name: string;
}

export enum CountryList {
  ca = 'canada',
  us = 'united states',
  au = 'australia',
  de = 'germany',
  jp = 'japan',
  br = 'brazil',
  uk = 'united kingdom',
  gb = 'united kingdom',
}

export const countriesWithStates: Record<string, State[]> = Object.freeze({
  [CountryList.ca]: [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon Territories' },
  ],
  [CountryList.us]: [
    { code: 'AA', name: 'Armed Forces Americas' },
    { code: 'AE', name: 'Armed Forces Europe' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AL', name: 'Alabama' },
    { code: 'AP', name: 'Armed Forces Pacific' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'DE', name: 'Delaware' },
    { code: 'FL', name: 'Florida' },
    { code: 'FM', name: 'Micronesia' },
    { code: 'GA', name: 'Georgia' },
    { code: 'GU', name: 'Guam' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'IA', name: 'Iowa' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MD', name: 'Maryland' },
    { code: 'ME', name: 'Maine' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MT', name: 'Montana' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NY', name: 'New York' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'PW', name: 'Palau' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UM', name: 'U.S. Minor Outlying Islands' },
    { code: 'UT', name: 'Utah' },
    { code: 'VA', name: 'Virginia' },
    { code: 'VI', name: 'U.S. Virgin Islands' },
    { code: 'VT', name: 'Vermont' },
    { code: 'WA', name: 'Washington' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WY', name: 'Wyoming' },
  ],
  [CountryList.au]: [
    { code: 'SA', name: 'South Australia' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'NSW', name: 'New South Wales' },
    { code: 'NT', name: 'Northern Territory' },
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'WA', name: 'Western Australia' },
    { code: 'TAS', name: 'Tasmania' },
  ],
});
